import Modal from 'react-modal';
import styled from 'styled-components';
import { FiXCircle } from 'react-icons/fi';

interface IModalProps {
	modalIsOpen: boolean;
	closeModal: () => void;
	onConfirm: () => void;
}

export function ModalEndCampaign({ modalIsOpen, closeModal, onConfirm }: IModalProps) {
	return (
		<Modal
			isOpen={modalIsOpen}
			shouldCloseOnEsc={true}
			shouldCloseOnOverlayClick={true}
			onRequestClose={closeModal}
			ariaHideApp={false}
			style={{
				overlay: {
					width: '100%',
					zIndex: 9999999,
					margin: 'auto',
					backgroundColor: 'rgba(0, 0, 0, 0.75)',
				},
				content: {
					maxWidth: '500px',
					maxHeight: '300px',
					width: '80%',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					borderRadius: '15px',
					margin: '100px auto',
					padding: '20px',
					position: 'relative',
				},
			}}
		>
			<Container>
				<CloseButton onClick={closeModal}>
					<FiXCircle color="#174f68" size={30} />
				</CloseButton>

				<Title>Encerrar Campanha</Title>

				<Message>
					Você está encerrando está campanha. Ao clicar em "Encerrar" Você não receberá novas doações,
					mas poderá resgatar o saldo em seu Painel Financeiro, se houver.
				</Message>

				<ButtonContainer>
					<CancelButton onClick={closeModal}>
						Cancelar
					</CancelButton>
					<ConfirmButton onClick={onConfirm}>
						Encerrar
					</ConfirmButton>
				</ButtonContainer>
			</Container>
		</Modal>
	);
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 20px;
  text-align: center;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 15px;
  right: 15px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  
  &:hover {
    opacity: 0.7;
  }
`;

const Title = styled.h2`
  font-family: 'Nunito', sans-serif;
  font-size: 24px;
  font-weight: 600;
  color: #174f68;
  margin-bottom: 20px;
  margin-top: 10px;
`;

const Message = styled.p`
  font-family: 'Nunito', sans-serif;
  font-size: 16px;
  color: #333;
  line-height: 1.5;
  margin-bottom: 30px;
  text-align: center;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 15px;
  justify-content: center;
  width: 100%;
`;

const Button = styled.button`
  font-family: 'Nunito', sans-serif;
  font-size: 16px;
  font-weight: 600;
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 100px;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
`;

const CancelButton = styled(Button)`
  background-color: #f5f5f5;
  color: #333;
  border: 1px solid #ddd;
  
  &:hover {
    background-color: #e9e9e9;
  }
`;

const ConfirmButton = styled(Button)`
  background-color: #dc3545;
  color: white;
  
  &:hover {
    background-color: #c82333;
  }
`; 